const legacy_msi = "legacy_msi";
const legacy_prism_pools = "legacy-prism-pools";
const mutations_prioritized = "mutations_prioritized";
const mutation_protein_change = "mutation_protein_change";
const subtype_matrix = "subtype_matrix";

export default {
  legacy_msi,
  legacy_prism_pools,
  mutations_prioritized,
  mutation_protein_change,
  subtype_matrix,
};
